export default __webpack_public_path__ + "static/audio-02ef36dbb54b7d9d705782d4ef9752eb.png";